import { render, staticRenderFns } from "./myBuyersBuyerHistory.vue?vue&type=template&id=bc727abc&scoped=true&lang=html&"
import script from "./myBuyersBuyerHistory.vue?vue&type=script&lang=js&"
export * from "./myBuyersBuyerHistory.vue?vue&type=script&lang=js&"
import style0 from "./myBuyersBuyerHistory.vue?vue&type=style&index=0&id=bc727abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc727abc",
  null
  
)

export default component.exports